import { createSelector } from 'reselect';
import { initialState } from './current-user.reducers';

const selectCurrentUser = (state: any) => state.currentUserReducer || initialState;

const makeSelectCurrentUser = () =>
  createSelector(
    selectCurrentUser,
    currentUserState => currentUserState.currentUser,
  );

const makeSelectToken = () =>
createSelector(
  selectCurrentUser,
  currentUserState => currentUserState.token,
);

export { makeSelectCurrentUser, makeSelectToken, selectCurrentUser };
